import { AuthService } from "@/application/services/user/auth.service";
import { MainPage } from "@/interface/pages/main-page";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: RouteComponent,
  beforeLoad: () => {
    const isAuthenticated = AuthService.getAuthenticatedState();
    if (isAuthenticated) {
      throw redirect({
        to: "/users/home",
        replace: true,
      });
    }
  },
});

function RouteComponent() {
  return <MainPage />;
}
